import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  ComponentRef,
  Type,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'upsell-offer-spinner-v2',
  templateUrl: './upsell-offer-spinner-v2.html',
  styleUrls: ['./upsell-offer-spinner-v2.scss']
})
export class UpsellOfferSpinnerV2Component implements AfterViewInit, OnDestroy {
  @Input() title: string;
  @Input() description: string;
  @Input() spinButtonText: string;
  @Input() spinnedTitle: string;
  @Input() spinnedDescription: string;
  @Input() spinnedButtonText: string;
  @Input() declineButtonText: string;
  @Input() wheelCenterImage: string;
  @Input() wheelOptions: any;
  @Input() pointerAngle: number = 90;
  @Input() closeAfterSpinTime: number = 0;
  @Output() closed = new EventEmitter<void>();
  private spinnerKeyFrames: string = '';
  public spinningState: string = 'not-spinning';

  private rotationStartDegrees: string;
  private rotationDegrees: string = '4215';

  ngAfterViewInit(): void {
    this.rotationStartDegrees = (
      Math.floor(Math.random() * this.wheelOptions?.length) * (360 / this.wheelOptions?.length)
    ).toString() || '120';

    const rightAnswerIndex = this.wheelOptions?.findIndex((option: any) => {
      return option.actualOffer === true;
    });

    const offerAngle = (
      3600 // 10 spins
      + ((360 / this.wheelOptions?.length) / 2) // Add half the angle of one option.
      - this.pointerAngle // Subtract the angle at which the pointer is at.
      + (rightAnswerIndex * (360 / this.wheelOptions?.length)) // Increament the total by the full angle for the number of options
    ).toString();

    this.rotationDegrees = offerAngle || '3495';



    this.spinnerKeyFrames = `
            .main-page-element {
              filter: blur(10px);
              filter:progid:DXImageTransform.Microsoft.Blur(pixelradius='10', shadowopacity='0.0');
            }
      
            upsell-offer-spinner .spinnerWheelMotor {
              transform: rotate(${this.rotationStartDegrees}deg);
            }
      
            upsell-offer-spinner .spinnerWheelMotor.spinned {
              transform: rotate(${this.rotationDegrees}deg)
            }
      
            upsell-offer-spinner .spinnerWheelMotor.spinning {
              transform: rotate(${this.rotationDegrees}deg)
            }
      
            @keyframes spinTheWheel {
              0% {
                transform: rotate(${this.rotationStartDegrees}deg)
              }
              100% {
                transform: rotate(${this.rotationDegrees}deg)
              }
            }
          `;

    let scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    console.log(scrollAvoid);
    scrollAvoid.classList.add('avoid');
  }

  closeModal(clickedButton?: any) {
    console.log('spinner - the button you clicked was:', clickedButton);
    let scrollAvoid = document.getElementsByClassName('scroll-content')[0];
    let modal = document.getElementsByClassName('modal')[0];
    console.log('spinner - modal', modal);
    modal.classList.remove('show');
    scrollAvoid.classList.remove('avoid');
    modal.classList.add('modal-hidden');
    this.removeSpinnerStyles();
    this.close();
  }

  close(): void {
    this.closed.emit();
  }

  ngOnDestroy(): void {
  }

  spinTheWHeel() {
    this.spinningState = 'spinning';
    setTimeout(() => {
      this.spinningState = 'spinned';
      if (this.closeAfterSpinTime) {
        setTimeout(() => {
          this.close();
        }, this.closeAfterSpinTime * 1000);
      }
    }, 4999);
  }

  setSpinnerStyles() {
    const body = document.getElementsByTagName('body')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.setAttribute('id', 'spinner-specific-styles');
    style.appendChild(document.createTextNode(this.spinnerKeyFrames));
    body.appendChild(style);
  }

  removeSpinnerStyles() {
    const body = document.getElementsByTagName('body')[0];
    const style = document.getElementById('spinner-specific-styles');
    console.log('spinner - styles', style);
    if (style) { body.removeChild(style); }
  }
}